import React from 'react';
import classes from "../PartersName/PartnersName.module.css";

const PartnersName = (props) => {
    return (
        <div className={ classes.partner__without_img }>{ props.name }</div>
    );
};

export default PartnersName;